import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.setupClickableRows()
  }

  setupClickableRows() {
    // テーブル行にクリックイベントを設定
    document.querySelectorAll('.clickable-row').forEach(row => {
      row.addEventListener('click', (event) => {
        // ボタンやリンクがクリックされた場合は処理しない
        if (event.target.closest('.btn') || event.target.closest('a') || event.target.closest('button')) {
          return
        }

        const url = row.dataset.url
        if (url) {
          window.location.href = url
        }
      })
    })
  }
}
